import { getFetch } from '../fetch';
import { apiConfig } from '../config';

export type CourseContainerResponseData = {
    results?: CourseContainerDescription[];
};

export interface CourseContainerDescription {
    description?: string | null;
    description_teaser?: string | null;
    description_rest?: string | null;
}
export interface GetCourseContainerBySlugRequest {
    slug: string;
}

export function getCourseContainerBySlug(req: GetCourseContainerBySlugRequest): Promise<CourseContainerResponseData> {
    const { apiGetCourseContainerBySlug } = apiConfig.getStaticUrls();

    return getFetch(apiGetCourseContainerBySlug, { slug_exact: req.slug });
}
